import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Redirects the retired V1 builder URLs to their Audience Builder V2 equivalents (ASB-3706).
 *
 *   /audience-builder            -> /audience-builder-v2
 *   /audience-builder/edit/:id   -> /audience-builder-v2/edit/:id
 *   /audience-builder/view/:id   -> /audience-builder-v2/view/:id
 *
 * The audience id, query string and router state are carried over. `replace` keeps the
 * legacy URL out of the history stack so the browser Back button does not bounce.
 */
export function legacyBuilderTarget(mode, id) {
	if (mode && id) {
		return `/audience-builder-v2/${mode}/${encodeURIComponent(id)}`;
	}
	return "/audience-builder-v2";
}

function LegacyBuilderRedirect({ mode = null }) {
	const { id } = useParams();
	const location = useLocation();
	return (
		<Navigate
			to={{ pathname: legacyBuilderTarget(mode, id), search: location.search }}
			state={location.state}
			replace
		/>
	);
}

LegacyBuilderRedirect.propTypes = {
	mode: PropTypes.oneOf(["edit", "view"]),
};

export default LegacyBuilderRedirect;
